import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import './Styles.css';

const { Option } = Select;

class SelectProveedoresItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: false,
      texto: '',
    };

    this.buscarProveedores = debounce(this.buscarProveedores.bind(this), 300);
    // Contador de secuencia para descartar respuestas que llegan fuera de orden
    this.requestSeq = 0;
  }

  componentDidMount() {
    // Cargar los primeros 10 al abrir por primera vez
    this.buscarProveedores('');
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tipoProveedorId !== this.props.tipoProveedorId) {
      this.setState({ opciones: [] }, () => {
        this.buscarProveedores('', true);
      });
      return;
    }
    // En modo múltiple "value" es un arreglo de ids, no texto de búsqueda
    if (this.props.mode === 'multiple' || this.props.mode === 'tags') return;
    if(prevProps.value !== this.props.value) {
      // Si el valor cambia, reiniciar las opciones
      if(this.props.value){
        const buscarProveedor = this.state.opciones.find(proveedor => proveedor._id.toString() === this.props.value.toString());
        if (!buscarProveedor){
          this.buscarProveedores(this.props.value || '', true);
        }
      }else{
        this.setState({ opciones: [] }, () => {
           this.buscarProveedores('', true);
        });
      }
    }
  }

  async buscarProveedores(texto, inicial, append = false) {
    const seq = ++this.requestSeq;
    const valorComoTexto = typeof this.props.value === 'string' ? this.props.value : '';
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "proveedores/selectProveedoresItem",
        {
          empresaId: this.props.empresaId,
          query: append ? (this.state.texto || texto || valorComoTexto) : (texto || valorComoTexto),
          skip: append ? this.state.opciones.length : 0,   // saltar los ya cargados
          factorajeFinancieroCXC: this.props.factorajeFinancieroCXC || false,
          tipoProveedorId: this.props.tipoProveedorId || undefined,
        },
        {
          headers: this.props.headersToken,
        }
      );

      // Descartar respuesta obsoleta
      if (seq !== this.requestSeq) return;

      if (res.data.success === 2) {
        this.setState((prev) => ({
          opciones: append ? [...prev.opciones, ...res.data.proveedores] : res.data.proveedores,
          primerCarga: false,
          texto: append ? this.state.texto : texto
        }));
        if(this.props.puntoVenta && inicial) {
          this.props.onChange(res.data.proveedores[0]?._id, res.data.proveedores[0]);
        }
      } else {
        this.setState({ opciones: [] });
      }
    } catch (error) {
      if (seq !== this.requestSeq) return;
      console.error("Error al buscar proveedores:", error);
      this.setState({ opciones: [], texto: append ? this.state.texto : texto });
    } finally {
      if (seq !== this.requestSeq) return;
      // Asegurar que siempre se quite el loading
      this.setState({ cargando: false, texto: append ? this.state.texto : texto });
    }
  }


  render() {
    const {
      noBuscar,
      mode,
      selectAll,
      mostrarCarga,
      onSelectAll,
      disabled,
      fondoBlanco,
      sinBorde,
      width,
      style,
      placeholder,
      ...restProps
    } = this.props;

    const propsNuevas = {
      showSearch: !noBuscar,
      filterOption: false,
      onSearch: this.buscarProveedores,
      mode,
      notFoundContent: this.state.cargando ? (
        <div style={{ textAlign: 'center', padding: '8px' }}>
          <div style={{ marginTop: '8px', fontSize: '12px', color: '#999' }}>
            Buscando proveedores...
          </div>
        </div>
      ) : this.state.primerCarga ? 'No se encontraron proveedores' : null,
      // Mostrar loading en el input del select
      loading: this.state.cargando,
    };

    if (mode === 'multiple') {
      propsNuevas.maxTagCount = 'responsive';
    }

    const estiloFinal = {
      color: disabled ? 'black' : 'inherit',
      backgroundColor: disabled ? (fondoBlanco ? 'white' : 'white') : null,
      borderBottom: sinBorde ? 'none' : '1px solid #E0FFFFFF',
      borderRadius: '4px',
      transition: 'border-color 0.3s ease',
      boxShadow: sinBorde ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)',
      width: width || undefined,
      opacity: disabled ? 1 : undefined,
      ...style,
    };


    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={400}
        disabled={disabled}
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>
            {menu}
          </Spin>
        )}
        {...propsNuevas}
        {...restProps}
        onChange={(value) => {
          const proveedor = Array.isArray(value)
            ? this.state.opciones.filter((p) => value.includes(p._id))
            : this.state.opciones.find((p) => p._id === value);
          this.props.onChange(value, proveedor)
        }}
        placeholder={this.state.cargando && !this.state.primerCarga ? "Cargando..." : placeholder}
        style={estiloFinal}
        bordered={false}
        onPopupScroll={(e) => {
          const { target } = e;
          if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            // Llegaste al fondo → cargar más
            this.buscarProveedores(this.props.value || '', false, true);
          }
        }}
      >
        {this.state.opciones.map((proveedor) => (
          <Option key={proveedor._id} value={proveedor._id}>
            {proveedor.stringBuscar}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectProveedoresItem;